export enum ErrorMessageResource {
  INSUFFICIENT_BALANCE = 'bank-account:insufficient_transfer_balance',
}